import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';

import { objectToHttpParams, snakeizeParams } from '../../util';

@Injectable()
export class AppointmentRequestsService {
  private apiEndpoint  = '/api/v2/groups/';

  constructor(
    private http: HttpClient,
  ) { }

  get(groupId: number, patientId: number, filter: string = 'pending'): Observable<any> {
    return this.http.get(`${this.apiEndpoint}${groupId}/appointment_requests`, { params: objectToHttpParams({ patient_id: patientId, filter: filter }) })
      .map(response => response);
  }

  cancel(groupId: number, id: number): Observable<any> {
    return this.http.patch(`${this.apiEndpoint}${groupId}/appointment_requests/${id}`, { params: objectToHttpParams({ is_cancelled: true }) })
      .map(response => response);
  }

  sendPreferences(groupId: number, id: number, params: any): Observable<any> {
    return this.http.patch(`${this.apiEndpoint}${groupId}/appointment_requests/${id}`, snakeizeParams(params));
  }

  post(groupId: number, params: any): any {
    return this.http.post(`${this.apiEndpoint}${groupId}/appointment_requests/`, snakeizeParams(params));
  }
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/home/appointment-requests/appointment-requests.service.ts